import {
  RiEyeFill,
  RiPsychotherapyFill,
  RiStethoscopeFill,
  RiCapsuleFill,
  RiMicroscopeFill,
  RiPulseFill,
  RiEmpathizeFill,
  RiMindMap,
  RiMentalHealthLine,
  RiAppleLine,
  RiInfraredThermometerLine,
  RiCapsuleLine,
  GrUserPolice,
  RiMicroscopeLine,
  TbAmbulance,
  RiShieldCrossLine,
  RiBriefcase4Line,
  FiAirplay,
  MdOutlineFlip,
  PiTelegramLogoBold,
  RiMailStarLine,
  RiHourglassLine,
  RiHeartLine,
  RiHeartPulseLine,
  RiStethoscopeLine,
  RiVirusLine,
  RiDossierLine,
  RiEye2Line,
  FiUser,
  FiMail,
  VscBook,
  MdFormatItalic,
  GiMedicalDrip,
  FiMapPin,
  FiBriefcase,
  LuFileCheck,
  MdOutlineStorefront,
  LuAward,
  LiaFileInvoiceDollarSolid,
  FiThumbsUp,
  FiPhone,
} from "../assets/icons/vander";

export const medicalServices = [
  {
    icon: RiEyeFill,
    title: "Eye Care",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiPsychotherapyFill,
    title: "Psychotherapy",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiStethoscopeFill,
    title: "Primary Care",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiCapsuleFill,
    title: "Dental Care",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiMicroscopeFill,
    title: "Orthopedic",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiPulseFill,
    title: "Cardiology",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiEmpathizeFill,
    title: "Gynecology",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiMindMap,
    title: "Neurology",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiMentalHealthLine,
    title: "Dermatologists",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiAppleLine,
    title: "Nutritionists",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiInfraredThermometerLine,
    title: "Physical Therapists",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
];

export const counterData = [
  {
    target: "99",
    symbol: "%",
    titleOne: "Positive feedback",
    titleTwo: "From Doctors",
  },
  {
    target: "25",
    symbol: "+",
    titleOne: "Experienced Clinics",
    titleTwo: "High Qualified",
  },
  {
    target: "1251",
    symbol: "+",
    titleOne: "Questions & Answers",
    titleTwo: "Your Questions",
  },
];

export const category = [
  {
    icon: GrUserPolice,
    title: "Doctors",
    desc: "Due to its wide spread use as filler text",
  },
  {
    icon: RiCapsuleLine,
    title: "Clinics",
    desc: "Due to its wide spread use as filler text",
  },
  {
    icon: RiMicroscopeLine,
    title: "Labs",
    desc: "Due to its wide spread use as filler text",
  },
  {
    icon: TbAmbulance,
    title: "Emergency",
    desc: "Due to its wide spread use as filler text",
  },
  {
    icon: RiShieldCrossLine,
    title: "Insurance",
    desc: "Due to its wide spread use as filler text",
  },
];
export const ctaData = [
  {
    icon: RiBriefcase4Line,
    title: "Our Mission",
    desc: "The most well-known dummy text is the Lorem Ipsum, which is said to have originated in the 16th century.",
  },
  {
    icon: FiAirplay,
    title: "Our Vision",
    desc: "The most well-known dummy text is the Lorem Ipsum, which is said to have originated in the 16th century.",
  },
  {
    icon: MdOutlineFlip,
    title: "Who We Are ?",
    desc: "The most well-known dummy text is the Lorem Ipsum, which is said to have originated in the 16th century.",
  },
];

export const accordionData = [
  {
    id: 1,
    title: "How does it work ?",
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    id: 2,
    title: "Do I need a designer to use Doctris ?",
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    id: 3,
    title: "What do I need to do to start selling ?",
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    id: 4,
    title: "What happens when I receive an order ?",
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
];
export const contactData = [
  {
    icon: RiStethoscopeFill,
    title: " Unify Body and Soul",
    desc: "Awaken your inner well-being and discover harmony for mind, body, and spirit.",
  },
  {
    icon: RiMicroscopeLine,
    title: "Peace, Balance & Wholeness",
    desc: "Discover the healing power of Ayurveda guided by spiritual light.",
  },
  {
    icon: GrUserPolice,
    title: "Personal care & natures embrace",
    desc: "Nurturing care, enveloped by natures serenity. Find your path to well-being.",
  },
];

export const adminFeature = [
  {
    icon: PiTelegramLogoBold,
    title: "New Messages",
    desc: "Due to its wide spread use as filler text",
  },
  {
    icon: RiMailStarLine,
    title: "Latest Proposals",
    desc: "Due to its wide spread use as filler text",
  },
  {
    icon: RiHourglassLine,
    title: "Package Expiry",
    desc: "Due to its wide spread use as filler text",
  },
  {
    icon: RiHeartLine,
    title: "Saved Items",
    desc: "Due to its wide spread use as filler text",
  },
];

export const mailData = [
  {
    name: "Amy Lucier",
    desc: "In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do.",
    date: "13th Sep 2023",
  },
  {
    name: "Tameika Whittle",
    desc: "The wise man therefore always holds in these matters to this principle of selection.",
    date: "29th Nov 2023",
  },
  {
    name: "Barbara Bayne",
    desc: "We denounce with righteous",
    date: "29th Dec 2023",
  },
  {
    name: "Nita Griffin",
    desc: "In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do.",
    date: "13th March 2023",
  },
  {
    name: "Marc Flythe",
    desc: "The wise man therefore always holds in these matters to this principle of selection.",
    date: "5th May 2023",
  },
  {
    name: "Elaine Hannah",
    desc: "pain avoided.",
    date: "19th June 2023",
  },
  {
    name: "Abraham Edwards",
    desc: "We denounce with righteous",
    date: "20th June 2023",
  },
  {
    name: "Allie Smith",
    desc: "In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do.",
    date: "31st Aug 2023",
  },
  {
    name: "Eleanor Cisco",
    desc: "The wise man therefore always holds in these matters to this principle of selection.",
    date: "1st Sep 2023",
  },
  {
    name: "Troy Turk",
    desc: "pain avoided.",
    date: "13th Sep 2023",
  },
  {
    name: "Tyron Elliott",
    desc: "We denounce with righteous",
    date: "29th Nov 2023",
  },
  {
    name: "Betty Cook",
    desc: "We denounce with righteous",
    date: "29th Dec 2023",
  },
  {
    name: "Doris Morrison",
    desc: "In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do.",
    date: "13th March 2023",
  },
  {
    name: "Chad Potter",
    desc: "The wise man therefore always holds in these matters to this principle of selection.",
    date: "5th May 2023",
  },
];
export const experienceData = [
  {
    time: "2010 - 2014",
    title: "Master Of Science",
    name: "X.Y.Z Hospital (NZ)",
  },
  {
    time: "2014 - 2016",
    title: "Gynecology Test",
    name: "X.Y.Z Hospital (NZ)",
  },
  {
    time: "2016 - 2019",
    title: "Master Of Medicine",
    name: "X.Y.Z Hospital (NZ)",
  },
  {
    time: "2019 - 2020",
    title: "Orthopedics",
    name: "X.Y.Z Hospital (NZ)",
  },
  {
    time: "2020 to continue..",
    title: "Gynecologist (Final)",
    name: "X.Y.Z Hospital (NZ)",
  },
];

export const paymentTwo = [
  {
    name: "Cardiogram",
    title: "Full bill paid",
  },
  {
    name: "Covid Test",
    title: "Full bill paid",
  },
  {
    name: "Checkup",
    title: "Full bill paid",
  },
  {
    name: "Dentist",
    title: "Full bill paid",
  },
  {
    name: "Eye Test",
    title: "Full bill paid",
  },
  {
    name: "Orthopedic",
    title: "Full bill paid",
  },
];

export const MonthlyReport = [
  {
    title: "Treatment report",
    progress: "84%",
  },
  {
    title: "State of being report",
    progress: "79%",
  },
  {
    title: "Health department report",
    progress: "95%",
  },
  {
    title: "Questionnaire",
    progress: "90%",
  },
  {
    title: "Covid-19 report",
    progress: "75%",
  },
  {
    title: "Blood pressure report",
    progress: "97%",
  },
];
export const patientProfile = [
  {
    icon: FiUser,
    title: "Gender",
    name: "Female",
  },
  {
    icon: FiMail,
    title: "Birthday",
    name: "13th Sep 1993",
  },
  {
    icon: VscBook,
    title: "Phone No.",
    name: "+(125) 458-8547",
  },
  {
    icon: MdFormatItalic,
    title: "Address",
    name: "Sydney, Australia",
  },
  {
    icon: GiMedicalDrip,
    title: "Blood Group",
    name: "B +",
  },
];

export const franchiseProcess = [
  {
    icon: FiAirplay,
    title: "Registration",
  },
  {
    icon: FiMapPin,
    title: "Store Location",
  },
  {
    icon: FiBriefcase,
    title: "Agreement",
  },
  {
    icon: LuFileCheck,
    title: "Documentation",
  },
  {
    icon: MdOutlineStorefront,
    title: "Store Execution",
  },
  {
    icon: LuAward,
    title: "Inauguration",
  },
];

export const faqAbout = [
  {
    icon: VscBook,
    title: "Get started",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: LiaFileInvoiceDollarSolid,
    title: "Pricing plan",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: FiThumbsUp,
    title: "Sales questions",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
];
export const acccordianData = [
  {
    id: 1,
    title: "How does it work ?",
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    id: 2,
    title: "Do I need a designer to use Doctris ?",
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    id: 3,
    title: "What do I need to do to start selling ?",
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    id: 4,
    title: "What happens when I receive an order ?",
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
];

export const contact = [
  {
    icon: FiPhone,
    title: "Phone",
    desc: "For assistance or to schedule an appointment, call us at",
    link: "tel:+152534-468-854",
    name: "+91  70229 40964",
  },
  {
    icon: FiMail,
    title: "Email",
    desc: "For questions or additional information, email us at",
    link: "mailto:rangabandimalavalli@gmail.com",
    name: "rangabandimalavalli@gmail.com",
  },
  {
    icon: FiMapPin,
    title: "Location",
    desc: (
      <>
        {"Rangabandi Malavalli Trust (R)"}
        <br />
        {
          "No. 365, 4th Cross, Near Temple, Siddharthanagar Malavalli, Mandya District"
        }
      </>
    ),
    link: "https://maps.app.goo.gl/VuraBHeiXQaxL16MA",
    name: "View on Google map",
  },
];
